<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车辆年检</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- banner -->
    <div class="inspectiontype-bg"></div>
    <!-- center -->
    <div class="inspectiontype-List">
      <div class="inspectiontype-box" v-for="(item,index) in productList" @click="toShopList(item.id,item.name,item.type)">
        <div class="inspectiontype-left">
          <div class="inspectiontype-img">
            <img class="inspectiontype-icon" :src="item.thumb" />
          </div>
          <div class="inspectiontype-describe">
            <div class="inspectiontype-desc-title">{{item.name}}</div>
            <div class="inspectiontype-desc-de">{{item.detail}}</div>
          </div>
        </div>
        <div class="inspectiontype-right">
          <img class="inspectiontype-more" src="/static/xiangyou.png" />
        </div>
      </div>
     <!-- <div class="inspectiontype-box" @click="toYeartype()">
        <div class="inspectiontype-left">
          <div class="inspectiontype-img">
            <img class="inspectiontype-icon" src="/static/daijianianjian.png" />
          </div>
          <div class="inspectiontype-describe">
            <div class="inspectiontype-desc-title">代驾车检</div>
            <div class="inspectiontype-desc-de">专业师傅 通过率高</div>
          </div>
        </div>
        <div class="inspectiontype-right">
          <div class="inspectiontype-price">￥398</div>
          <img class="inspectiontype-more" src="/static/xiangyou.png" />
        </div>
      </div>
      <div class="inspectiontype-box">
        <div class="inspectiontype-left">
          <div class="inspectiontype-img">
            <img class="inspectiontype-icon" src="/static/liunianmianjian.png" />
          </div>
          <div class="inspectiontype-describe">
            <div class="inspectiontype-desc-title">六年免检</div>
            <div class="inspectiontype-desc-de">足不出户 寄送到家</div>
          </div>
        </div>
        <div class="inspectiontype-right">
          <img class="inspectiontype-more" src="/static/xiangyou.png" />
        </div>
      </div> -->
    </div>
    <!-- bottom -->
    <div class="inspectiontype-bottom">
      <div class="inspectiontype-bottomtitle">
        <img class="inspectiontype-tipicon" src="/static/newprojecticon/title.png" />
        <div class="inspectiontype-tiptext">为什么选择我们</div>
      </div>
      <div class="inspectiontype-boxlist">
        <div class="inspectiontype-botbox">
          <img class="inspectiontype-topimg" src="/static/hangyelingxian.png" />
          <div class="inspectiontype-bottext1">行业领先</div>
          <div class="inspectiontype-bottext2">合作100+年检机构</div>
        </div>
        <div class="inspectiontype-botbox">
          <img class="inspectiontype-topimg" src="/static/zhuanyetiexin.png" />
          <div class="inspectiontype-bottext1">专业贴心</div>
          <div class="inspectiontype-bottext2">专注解决您的年检难题</div>
        </div>
        <div class="inspectiontype-botbox">
          <img class="inspectiontype-topimg" src="/static/jisushengshi.png" />
          <div class="inspectiontype-bottext1">急速省时</div>
          <div class="inspectiontype-bottext2">免除繁琐，专享通道</div>
        </div>
        <div class="inspectiontype-botbox">
          <img class="inspectiontype-topimg" src="/static/fuwutouming.png" />
          <div class="inspectiontype-bottext1">服务透明</div>
          <div class="inspectiontype-bottext2">价格透明，服务公道</div>
        </div>
      </div>
    </div>
    <img class="inspectiontype-orderimg" src="/static/nianshenorder.png" @click="toAnnualReview()"/>
  </div>
</template>

<script>
  import httper from "../../api/http";
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        productId: "",
        productList:""
      }
    },
    created() {
      if (this.$route.query.product_id) {
        this.productId = Number(this.$route.query.product_id);
      } else {
        this.productId = "";
      }
      this.request("getProductList", {
        type: 5
      })
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.push({
          path: "/"
        })
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      toAnnualReview(){
        this.$router.push({
          path: "/annualReviewList"
        })
      },
      toYeartype() {
        this.$router.push({
          path: "/yearlyInspection",
          query: {
            product_id: this.productId
          }
        })
      },
      toShopList(id,name,type) {
        if(name=='六年免检'){
          this.$toast({
            message: '暂未开放',
          })
        }else if(name=='预约年检'){
          this.$router.push({
            path: "/serviceList",
            query: {
              product_id: id,
              isYearInspection: true,
              product_name:name,
              product_type:type
            }
          })
        }else{
          this.$router.push({
            path: "/yearlyInspection",
            query: {
              product_id: id,
              isYearInspection: true,
              product_name:name,
              product_type:type
            }
          })
        }

      },
      // 调用接口
      request(type = "", requestData = {}) {
        let that = this;
        let data = {};
        switch (type) {
          // 商品分类列表
          case "getProductList":
            httper.get("/product/get-product-by-type", requestData, res => {
              if(res.code==0){
                console.log("商品列表", res)
                this.productList = res.data
              }else{
                this.$toast({
                  message: res.message || '系统异常',
                })
              }

            },false);
            break;
        }
      },
    }
  }
</script>

<style>
  .inspectiontype-bg {
    width: 100%;
    height: 195px;
    background-size: 100% 100%;
    background-image: url(../../../static/nianshenbg.png);
  }

  .inspectiontype-List {
    width: calc(100% - 40px);
    margin: 0 20px;
    position: relative;
    top: -46px;
  }

  .inspectiontype-box {
    width: 100%;
    height: 90px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    background-color: #FFFFFF;
  }

  .inspectiontype-left {
    display: flex;
    align-items: center;

  }

  .inspectiontype-img {
    width: 38px;
    height: 38px;
    margin-right: 10px;
  }

  .inspectiontype-icon {
    width: 100%;
    height: 100%;

  }

  .inspectiontype-describe {}

  .inspectiontype-desc-title {
    font-size: 14px;
    color: #FD8C00;
    margin-bottom: 10px;
  }

  .inspectiontype-desc-de {
    font-size: 12px;
    color: #666;

  }

  .inspectiontype-right {
    display: flex;
    align-items: center;
  }

  .inspectiontype-price {
    font-size: 14px;
    margin-right: 20px;
    font-weight: bold;
    font-style: italic;
    color: #FD8C00;
  }

  .inspectiontype-more {
    width: 15px;
    height: 15px;
  }

  .inspectiontype-bottom {
    width: calc(100% - 40px);
    margin: -46px 20px 100px 20px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
  }

  .inspectiontype-bottomtitle {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .inspectiontype-tipicon {
    width: 4px;
    height: 23px;
    margin-right: 10px;
  }

  .inspectiontype-tiptext {
    font-size: 12px;
  }

  .inspectiontype-boxlist {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .inspectiontype-botbox {
    /*   width: 23%;
    margin-left: 10px; */
    margin-left: 4%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .inspectiontype-topimg {
    width: 46px;
    height: 46px;
  }

  .inspectiontype-bottext1 {
    font-size: 10px;
  }

  .inspectiontype-bottext2 {
    font-size: 8px;
    color: #666666;
  }
  .inspectiontype-orderimg{
    width: 65px;
    height: 65px;
    position: fixed;
    bottom: 20px;
    right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/yearInspectionType.vue